import { MODAL_TYPE_INSTORE_HIW } from 'core/modules/OldModal/types';

export const INSTORE_HIW_TYPE = MODAL_TYPE_INSTORE_HIW;
export const HEADER_HIW_TYPE = 'headerSectionHiw';
export const MANAGE_CARDS_HIW_TYPE = 'mt_manageCardsHiw';
export const OFFER_LINK_HIW_FIRST_TYPE = 'mt_offerLinkHiwFirst';
export const OFFER_LINK_HIW_SECOND_TYPE = 'mt_offerLinkHiwSecond';
